module.exports = __webpack_public_path__ + "static/media/whos_a_good_boy.6b43e16c.jpg";